import PlainFieldset from 'app/common/ui-next/plain-fieldset';
import PlainRadioButton from 'app/common/ui-next/plain-radio-button';

import useBuildingsData from '../../../commonHooks/useBuildingsData';
import useMenuTargetItemHandling from './useMenuTargetItemHandling';
import useMenuTargetItemState from './useMenuTargetItemState';
import { SyntheticEvent } from 'react';

/**
 *  Выбор корпуса
 */

type Props = {
  orgId: number,
  direction: 'from' | 'to',
  disabled?: boolean,
  defaultBuildingId?: number | null,
  onChange: (buildingId: string) => void,
}

const MenuBuildingSelector = ({
  orgId,
  direction,
  disabled,
  defaultBuildingId,
  onChange
}: Props) => {
  const [[{ itemsCurrent: buildings }, buildingsLoading]] = useBuildingsData(orgId);
  const buildingState = useMenuTargetItemState();
  const [buildingCurrent, buildingCurrentSingle] = buildingState;

  const handleRadioButtonChange = useMenuTargetItemHandling(
    buildingState,
    buildings,
    defaultBuildingId,
  );

  const unicSetId = `buildings_${direction}`;

  const onChangeHandler = (e: SyntheticEvent<HTMLInputElement, Event>) => {
    handleRadioButtonChange(e)
    const { value } = e.currentTarget;
    onChange(value)
  }

  if (buildingCurrentSingle) {
    return null;
  }

  return (
    <PlainFieldset
      legend={direction === 'from' ? 'Из корпуса' : 'В корпус'}
      name={unicSetId}
    >
      {buildings.map(({ id, title }) => (
        <PlainRadioButton
          key={id}
          value={String(id)}
          checked={buildingCurrent === id}
          label={title}
          name={unicSetId}
          disabled={buildingsLoading || disabled}
          onChange={onChangeHandler}
        />
      ))}
    </PlainFieldset>
  );
};

export default MenuBuildingSelector;
